<div class="paybee-modal-header pb-0">
    <div class="row">
        <div class="col-12">
            @if(isSimpleRaffle){
                <div class="modal-main-heading" >See Winner(s)</div>
                <div class="modal-main-heading body-1 text-gray" >
                    Viewing the winner(s) of <span class="text-bold">{{campaign.name}}</span>
                </div>
            } @else{
                <div class="modal-main-heading" >See Winners</div>
                <div class="modal-main-heading body-1 text-gray" >
                    Viewing the winners of <span class="text-bold">{{campaign.name}}</span>
                </div>
            }
        </div> 
    </div>
</div>
<div class="modal-body">
    @if(isSimpleRaffle){
        @for(item of data; track $index){
            <div class="mb-3"
            [ngClass]="{'pb-5': $index === data.length - 1}">
            <div class="d-flex justify-content-between mb-3 px-3">
                <div class="d-flex">
                <div class="user-badge mr-3" [ngStyle]="{'background-color': initialsService.userDataMap.get(item.winnerUser.name)?.color}">
                    {{initialsService.userDataMap.get(item.winnerUser.name)?.initials}}
                </div>
                <div class="body-1 d-flex flex-column justify-content-center">{{item.winnerUser.name}}</div>  
                </div>
                <div class="d-flex flex-column justify-content-center">
                <i (click)="onRemoveWinnerFromSimpleRaffle(item)" class="black-text far fa-trash-alt p2p-popover-icon cursor--pointer mr-2"></i>
                </div>
            </div>  

            @if ($index !== data.length - 1) {
                <div class="divider mt-3"></div>
            }
           
            </div>            
        } @empty{
            <div class="body-1 p-2 text-center pb-5">No winners available</div>
        }
    } @else{
        @for(winner of data; track $index){
            <div class="d-flex justify-content-between mt-3"
            [ngClass]="{'pb-5': $index === data.length - 1}">
                <div class="d-flex">
                    <img src="{{getImg(winner.BasketRaffleItem.image)}}" class="mr-3" style="width: 100px; height:50px;border-radius: 4px;" alt="">
                    <div class="body-1 d-flex align-items-center">{{winner.BasketRaffleItem.name}}</div>
                </div>
                
                <div class="d-flex flex-column justify-content-around">
                    <div class="body-2 grey-text" style="text-align:right">{{winner.Winner.name}}</div>
                    <div class="caption grey-text">{{winner.Winner.email}}</div>
                </div>
            </div>
            
            @if ($index !== data.length - 1) {
                <div class="divider mt-3"></div>
            }
        }
    }
</div>

<div class="modal-footer paybee-modal-footer d-flex justify-content-end">
    <div>
    <a (click)="onClose()" class="btn btn-sm modal-confirm-button waves-effect waves-light">Close</a>
    </div>
</div>  
